import type { InvitationResponseRolesItem } from 'generatedTypes/user/models';
import { useEffect, useState } from 'react';

import type { Item } from './types';

const useData = () => {
    const [roleItems, setRoleItems] = useState<Item[]>([]);

    const fetchRoles = () => {
        const roles: InvitationResponseRolesItem[] = ['Admin', 'Pilot'];

        setRoleItems(
            roles.map(role => ({
                label: role,
                value: role
            }))
        );
    };

    useEffect(() => {
        fetchRoles();
    }, []);

    return {
        roleItems
    };
};

export default useData;
